import React, { useEffect, useState } from 'react'
import axios from 'axios';

import logo from '../assets/Group 16228.png'
import heroImage from '../assets/Group 19777.png'
import heroBg from '../assets/Mask Group 21.png'

import playicon from '../assets/Group 19823.png'
import cloudicon from '../assets/Group 19826.png'
import cameraicon from '../assets/Group 19827.png'
import videoicon from '../assets/Group 19828.png'
import contacticon from '../assets/Group 19831.png'
import globeicon from '../assets/Group 19825.png'

import appstore from '../assets/app-store.png'
import playstore from '../assets/play-store.png'
import huwawei from '../assets/huawei-store.png'

import feature_1 from '../assets/Group-19735.png'
import feature_2 from '../assets/Group-19736.png'
import feature_3 from '../assets/Group-19737.png'
import feature_4 from '../assets/Group-19738.png'

import GTranslateDropdown from '../components/GTranslateDropdown'

import download from '../assets/download.svg'; // Add a play icon for videos
import card from '../assets/credit-card-svgrepo-com (1).svg'; // Add a play icon for videos


function LandingPage() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [reset, setreset] = useState(false);
    const [ResetPhone, setResetPhone] = useState('');
    const [ResetLoader, setResetLoader] = useState(false);
    const [resetmessage, setResetmessage] = useState("");


    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const [PrivacyLink, setPrivacyLink] = useState('')
    const [TermsLink, setTermsLink] = useState('')

    function Login(phone, password, country) {
        setLoading(true)
        axios.get(`https://apiv2.mobileartsme.com/login`, {
            params: {
                serviceid: 2,
                phonenumber: phone,
                password: password,
                type: 'signin',
                country: country
            }
        })
            .then(response => {
                if (response.data.Error === 0) {

                    setError(false)
                    localStorage.setItem('Sb_UserId', response.data.Result.UserID)
                    window.location.href = '/home';
                    setLoading(false)
                } else {
                    console.error("Login failed:", response.data);
                    setError(true)
                    setErrorMessage(response.data.Result)
                    setLoading(false)

                }
            })
            .catch(error => {
                console.error("Error during login:", error);
            });



    }


    function openreset() {
        setreset(true)
    }

    function closereset() {
        setreset(false)
        setResetmessage("")
    }



    function resetpass(phone) {
        setResetLoader(true)
        fetch(`http://apiv2.mobileartsme.com/resetpass?phonenumber=${phone}&IDService=2`)
            .then(res => res.json())
            .then(response => {

                setResetLoader(false)
                setResetmessage(response.result)
            })


    }

    useEffect(() => {
        const countrycode = sessionStorage.getItem("secretbox_country_code")
   

        if (countrycode === 'pl') {
            setPrivacyLink('https://ma-appsfiles.s3.eu-central-1.amazonaws.com/PrivacyPolicy/SecretboxPL.html')
            setTermsLink("https://ma-appsfiles.s3.eu-central-1.amazonaws.com/TermsAndConditions/regulaminDCB.html")
        } else {
            setPrivacyLink('https://ma-appsfiles.s3.eu-central-1.amazonaws.com/PrivacyPolicy/Default.html')
            setTermsLink("https://ma-appsfiles.s3.eu-central-1.amazonaws.com/TermsAndConditions/Default.html")
        }
    })

    return (
        <div>
            <section className='hero'>

                <div className='container' >
                    <div className='py-4 d-flex flex-row justify-content-between align-items-center'>
                        <img className='logo' src={logo} />
                        <div className='d-flex flex-row align-items-center gap-2' >
                            <GTranslateDropdown />
                            <button className='button_primary' onClick={() => window.location.href = '#loginsection'}>Login</button>
                        </div>
                    </div>

                    <div className='row'>

                        <div className='col-lg-6 d-flex flex-column justify-content-center' >
                            <h1 className='text-light' >Secure Your <br></br>
                                Digital World <br></br>
                                with <span className='bold' >Secret Box</span></h1>
                            <p className='pt-4'>With The Help Of Secret Box Your Chosen Pictures, Videos, Audios, Documents and Contacts are Backed Up & Available Only For You.</p>
                            <div className='pt-4 d-flex gap-2'>

                                <button className='button_primary d-flex align-items-center gap-2'
                                    onClick={() => window.location.href = '#downloadsection'}>  Download Now
                                    <img style={{ width: '30px' }} src={download} />

                                </button>

                                <button
                                    onClick={() => window.location.href = 'https://ma-appsfiles.s3.eu-central-1.amazonaws.com/AE_PaymentPage/index.html?portal=SecretBox'}
                                    className='button_primary d-flex align-items-center gap-2'
                                >Subscribe
                                    <img style={{ width: '30px' }} src={card} />
                                </button>
                            </div>
                        </div>

                        <div className='col-lg-6 d-flex flex-column justify-content-center' >
                            <img src={heroImage} />
                        </div>

                    </div>
                </div>


            </section>

            <section className='tabs-section py-5' >

                <div className='container pt-5 d-flex flex-column justify-content-center '>
                    <ul class="nav nav-pills mb-3 d-flex flex-row justify-content-center gap-3" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Free Features</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Premium</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Backup to cloud</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pills-hide-tab" data-bs-toggle="pill" data-bs-target="#pills-hide" type="button" role="tab" aria-controls="pills-hide" aria-selected="false">Hide your data</button>
                        </li>

                    </ul>



                    <div class="tab-content" id="pills-tabContent">


                        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">

                            <div className='feature ' >
                                <h2 className='text-center'>Free Features</h2>
                                <div className='row' >
                                    <div className='col-lg-5' >
                                        <img style={{ width: '100%' }} src={feature_1} />
                                    </div>


                                    <div className='col-lg-7 d-flex flex-column justify-content-center' >
                                        <div className='iconbox' >
                                            <img src={playicon} />
                                            <div>
                                                <h3>Multimedia</h3>
                                                <p>Hide Pictures, Videos, Audios & Files</p>
                                            </div>
                                        </div>

                                        <div className='iconbox' >
                                            <img src={contacticon} />
                                            <div>
                                                <h3>Contacts</h3>
                                                <p>Hide Contacts Directly In Secret Box</p>
                                            </div>
                                        </div>

                                        <div className='iconbox' >
                                            <img src={globeicon} />
                                            <div>
                                                <h3>Secret Web</h3>
                                                <p>Secret browsing</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>


                        <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                            <div className='feature ' >
                                <h2 className='text-center'>Premium</h2>
                                <div className='row' >
                                    <div className='col-lg-5' >
                                        <img style={{ width: '100%' }} src={feature_2} />
                                    </div>


                                    <div className='col-lg-7 d-flex flex-column justify-content-center' >
                                        <div className='iconbox' >
                                            <img src={cloudicon} />
                                            <div>
                                                <h3>Cloud Storage</h3>
                                                <p>Backup to cloud up to 10TB</p>
                                            </div>
                                        </div>

                                        <div className='iconbox' >
                                            <img src={playicon} />
                                            <div>
                                                <h3>Camera</h3>
                                                <p>Take pictures directly</p>
                                            </div>
                                        </div>

                                        <div className='iconbox' >
                                            <img src={videoicon} />
                                            <div>
                                                <h3>Video</h3>
                                                <p>Recover videos directly from camera</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
                            <div className='feature ' >
                                <h2 className='text-center'>Backup To Cloud</h2>
                                <div className='row' >
                                    <div className='col-lg-5' >
                                        <img style={{ width: '100%' }} src={feature_3} />
                                    </div>


                                    <div className='col-lg-7 d-flex flex-column justify-content-center' >
                                        <div className='iconbox' >
                                            <img src={cloudicon} />
                                            <div>
                                                <h3>Backup your data</h3>
                                                <p>Store And Backup Your Data On Cloud Up To 10 Tb For Premium Users Images Videos Audios Documents Contacts</p>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="tab-pane fade" id="pills-hide" role="tabpanel" aria-labelledby="pills-hide-tab" tabindex="0">
                            <div className='feature ' >
                                <h2 className='text-center'>Hide your data</h2>
                                <div className='row' >
                                    <div className='col-lg-5' >
                                        <img style={{ width: '100%' }} src={feature_4} />
                                    </div>


                                    <div className='col-lg-7 d-flex flex-column justify-content-center' >
                                        <div className='iconbox' >
                                            <img src={cloudicon} />
                                            <div>
                                                <h3>Backup your data</h3>
                                                <p>Store And Backup Your Data On Cloud Up To 10 Tb For Premium Users Images Videos Audios Documents Contacts</p>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </section>


            <section id='loginsection' className='py-5'>
                <div className='container'>
                    <div className='row'>


                        {loading ?
                            (
                                <div className='w-100 d-flex -flex-row align-items-center justify-content-center' style={{ height: '20vh' }} >
                                    <div className="loader"></div>
                                </div>
                            )
                            :
                            <div className='col-lg-5 d-flex flex-column justify-content-center py-4'>
                                <h3 className='text-light'>Login To Retrieve Your Secret Files</h3>
                                <div className='mt-4' >

                                    <input className='w-100 my-1' placeholder='Username' onChange={(e) => setUsername(e.target.value)} />

                                    <div className='w-100 d-flex gap-2 mt-1' >
                                        <input className='flex-1' placeholder='Password' onChange={(e) => setPassword(e.target.value)} />
                                        <button className='login-button'
                                            onClick={() => Login(username, password, "LB")}>
                                            Login</button>
                                    </div>
                                </div>
                                <p className='pt-2' onClick={() => openreset()}>Forgot Password ?</p>

                                {error ? (<p className='errormessage'>{errorMessage}</p>) : ""}

                            </div>}

                        <div className='col-lg-2'>
                        </div>

                        <div className='col-lg-5 d-flex flex-column justify-content-center py-4'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54.743" height="53.375" viewBox="0 0 54.743 53.375">
                                <path id="Path_7267" data-name="Path 7267" d="M14.194,46.795,2,56.375V5.737A2.737,2.737,0,0,1,4.737,3H54.006a2.737,2.737,0,0,1,2.737,2.737v38.32a2.737,2.737,0,0,1-2.737,2.737Zm-6.72-1.683L12.3,41.32H51.269V8.474H7.474Zm19.16-14.74h5.474v5.474H26.635Zm0-16.423h5.474V27.635H26.635Z" transform="translate(-2 -3)" fill="#fff"></path>
                            </svg>
                            <h3 className='text-light'>Send your feedback to</h3>
                            <h3 className='text-light' style={{ textDecoration: 'underline', fontWeight: '400' }} >vasshelpdesk@gmail.com</h3>

                        </div>
                    </div>

                    <div className='d-flex flex-column align-items-center pt-4' >
                        <img style={{ width: '14rem' }} src={logo} />
                        <div className='pt-4 d-flex flex-row gap-4'>

                            <a
                                data-bs-toggle="offcanvas" href="#privacyoffcanvas"
                                role="button" aria-controls="offcanvasExample">
                                Privacy Policy
                            </a>


                            <a
                                data-bs-toggle="offcanvas" href="#termsoffcanvas"
                                role="button" aria-controls="offcanvasExample">
                                Terms & Conditions
                            </a>


                        </div>

                        <div id='downloadsection' className='pt-4 d-flex flex-row align-items-center justify-content-center gap-2' >
                            <img
                                onClick={() => window.open('https://apps.apple.com/app/id6444834043', '_blank')}
                                src={appstore}
                                alt='appstore'
                            />

                            <img
                                onClick={() => window.open('https://play.google.com/store/apps/details?id=app.safe.vault', '_blank')}
                                src={playstore}
                                alt='playstore'
                            />

                            <img
                                onClick={() => window.open('https://appgallery.huawei.com/#/app/C109037749', '_blank')}
                                src={huwawei}
                                alt='appgallery'
                            />

                        </div>
                    </div>
                </div>
            </section>



            <div class="offcanvas offcanvas-end" tabindex="-1" id="privacyoffcanvas" >
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasExampleLabel">Privacy Policy</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                    <iframe style={{ width: '100%', height: '100%' }}
                        src={PrivacyLink}></iframe>
                </div>
            </div>


            <div class="offcanvas offcanvas-end" tabindex="-1" id="termsoffcanvas" >
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasExampleLabel">Terms & Conditions</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                    <iframe style={{ width: '100%', height: '100%' }}
                        src={TermsLink} ></iframe>
                </div>
            </div>



            {reset ? (
                <div className='resetModal' >
                    <div className='resetModalContent'>
                        <h3>Forgot your password?</h3>
                        <p className='mt-4 text-dark'>We will send you an SMS with your new password</p>
                        <input className='resetinput mt-2' placeholder='Phone Number' onChange={(e) => setResetPhone(e.target.value)} />
                        <p>{resetmessage}</p>
                        <div className='d-flex flex-row justify-content-end align-items-center mt-4' >
                            <button style={{ background: 'white', border: '1px solid white', color: '#3859C5' }}
                                onClick={() => closereset()}>Cancel</button>

                            <button onClick={() => resetpass(ResetPhone)} >
                                {ResetLoader ? <div style={{ width: '20px', height: '20px', padding: '4px' }} className='loader' ></div> : "Submit"}

                            </button>

                        </div>
                    </div>
                </div>
            ) : ""}
        </div>
    )
}

export default LandingPage